module.exports = __webpack_public_path__ + "static/media/camps.d9295b56.JPG";